var module = angular.module('sdCompanyProfileModule');
/**
 * Directive that handles the sticky nav bar for the Service Professional profile pages
 */
module.directive('companyProfileNav', ["$parse", "$compile", "$timeout", function ($parse, $compile, $timeout) {
    var $window = angular.element(window);
    var viewportHeight = $window.height();

    // Jump and activate menu items 10% (0.10) from the top
    var scrollOffset = viewportHeight * 0.10;

    // Menu items (keep in reversed DOM order)
    var offsetMap = {
        'qa': 0,
        'reviews': 0,
        'project-photos': 0,
        'about-us': 0
    };

    // On resize, recalculate the offsets to the top for the menu item Headers and the new viewport height
    var lazyOnResizeHandler = debounce(function () {
        updateOffsetMap();
        viewportHeight = $window.height();
    }, 100, false);

    function updateOffsetMap() {
        angular.element.each(offsetMap, function (id) {
            var element = angular.element('#' + id);
            if (!angular.isObject(element)) {
                offsetMap[id] = 0;
                return;
            }

            var offset = element.offset();
            if (!angular.isObject(offset)) {
                offsetMap[id] = 0;
                return;
            }
            offsetMap[id] = offset.top;
        });
    }

    return {
        restrict: 'A', // attribute only
        link: function (scope, element) {
            // This scope is not(!) isolated for performance reasons. Only use scope.companyProfileNav to avoid collision
            scope.companyProfileNav.active = 'about-us';
            var $navigation = $(element);

            // We only want to run some code once (like adding a clone)
            if (angular.element(element).hasClass('sticky') === false) {
                // Clone the nav bar to add a hidden sticky version add the bottom of the container
                var $clone = $navigation.clone();
                $clone.addClass('sticky d-none');
                var $container = angular.element('.company-profile');
                $container.append($compile($clone)(scope));

                // When the user scroll, trigger an update to see if the active state for menu items needs to update
                $window.on('scroll', function () {
                    scope.$apply(function () {
                        update(scope, $navigation, $clone);
                    });
                });
                // On resize we need to recalculate some values (offsets, viewport height)
                $window.on('resize', lazyOnResizeHandler);

                // Register a function to offset the jump height when clicking an anchor link (menu item)
                // Usage: ng-click="companyProfileNav.scrollTo($event, 'anchorID'")
                scope.companyProfileNav.scrollTo = function (event, id) {
                    $window.scrollTop(angular.element('#' + id).offset().top - scrollOffset + 1);
                    // $window.scrollTop is async to Angular, so we need a miniature delay
                    $timeout(function () {
                        scope.companyProfileNav.active = id;
                    }, 100);
                    event.preventDefault(); // Prevent the #anchor scroll jump
                };

                // Initial state update
                lazyOnResizeHandler();
                update(scope, $navigation, $clone);
            }
        }
    };

    // This function will run every time a user scrolls, so keep it light!
    function update(scope, $navigation, $clone) {
        //FIXME: DOM was not ready when updating offset map?
        if (offsetMap['qa'] === 0) {
            lazyOnResizeHandler();
            return;
        }

        var top = $window.scrollTop(); // Amount of pixels scrolled from the top
        var pos = $navigation.offset().top; // Amount of pixels the navbar is from the top

        // If scrolled passed the navbar, show the clone (sticky nav)
        if (top - pos > 0) {
            $clone.removeClass('hidden');
        } else { // Otherwise hide it..
            $clone.addClass('hidden');
        }

        // Check which menu item should be activated
        for (var id in offsetMap) {
            var offset = offsetMap[id];
            if (top + scrollOffset > offset) { // If scrolled passed the offset (header position) minus the offset
                // Set the menu item to active (overwrites until no longer scrolled far enough)
                scope.companyProfileNav.active = id;
                break;
            }
        }
    }

    // https://davidwalsh.name/javascript-debounce-function
    // Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If `immediate` is passed, trigger the function on the
    // leading edge, instead of the trailing.
    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }
}]);
